import React, { useEffect, useRef, useState } from 'react';
import FlexContainer from '../../../components/material-ui/adaptive/FlexContainer';
import CusButton from '../../../components/material-ui/CusButton';
import useToast from '../../../hooks/useToast';
import { useEventListener } from 'usehooks-ts';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import useColor from '../../../hooks/site/useColor';
import { Box, Stack } from '@mui/material';
import TransferAccount from '../modal/TransferAccount';
import DeleteAccount from '../modal/DeleteAccount';
import ShowContainer from '../../../components/material-ui/ShowContainer';

export default function UserSelectActions({ users, chosenList, setChosenList }) {
  const { infoToast, errorToast } = useToast();
  const { background } = useColor();
  const { isLessTablet, isMobile } = useBootstrapSize();
  const containerRef = useRef();

  const [activePin, setActivePin] = useState(false);
  const [openTransferAcc, setOpenTransferAcc] = useState(false);
  const [openDeleteAcc, setOpenDeleteAcc] = useState(false);

  const copyMarked = (indxValue) => {
    const valueList = [];
    for (let indxUser of chosenList) {
      const currentValue = users[indxUser][indxValue];
      if (currentValue) valueList.push(currentValue);
    }

    if (!valueList.length) {
      errorToast('The selected items have no values');
      return;
    }

    const text = valueList.join('\n');
    navigator.clipboard.writeText(text).then(() => {
      infoToast('copied to your clipboard');
    });
  };

  const buttonActions = [
    { id: 'copyTgId', label: 'Copy TG ID', onClick: () => copyMarked(8) },
    { id: 'copyEmail', label: 'Copy email', onClick: () => copyMarked(9) },
    { id: 'copyPhone', label: 'Copy phone', onClick: () => copyMarked(10) }
  ];

  const buttonAccActions = [
    {
      id: 'transAccounts',
      label: 'Transfer accounts',
      onClick: () => setOpenTransferAcc(true)
    },
    { id: 'deleteAccounts', label: 'Delete accounts', onClick: () => setOpenDeleteAcc(true) }
  ];

  useEventListener('scroll', () => {
    if (!containerRef.current) return;
    if (isLessTablet) return;

    const rect = containerRef.current.getBoundingClientRect();
    const currentTopOffset = rect.top;
    setActivePin(currentTopOffset <= 12);
  });

  useEffect(() => {
    if (!isLessTablet) return;
    setActivePin(false);
  }, [isLessTablet]);

  return (
    <>
      <ShowContainer condition={!isMobile || !!chosenList.length}>
        <Box
          ref={containerRef}
          width={'100%'}
          minHeight={30}
          sx={{
            opacity: +!!chosenList.length,
            pointerEvents: !chosenList.length ? 'none' : 'auto'
          }}>
          <FlexContainer
            gap={1}
            flexWrap="wrap"
            sx={
              activePin && {
                position: 'fixed',
                top: 0,
                width: containerRef.current?.offsetWidth,
                backgroundColor: background.default,
                padding: '12px 0',
                zIndex: 5
              }
            }>
            {buttonActions.map((el) => (
              <CusButton
                boxProps={el.sx}
                key={el.id}
                fullWidth
                text={el.label}
                onClick={el.onClick}
                sx={{ p: 1, height: 30 }}
              />
            ))}

            <Stack
              direction={isMobile ? 'column' : 'row'}
              gap={0.5}
              ml={isMobile ? '' : 'auto'}
              mt={isMobile ? 2 : 0}>
              {buttonAccActions.map((el) => (
                <CusButton
                  boxProps={el.sx}
                  key={el.id}
                  fullWidth
                  text={el.label}
                  onClick={el.onClick}
                  sx={{ p: 1, height: 30 }}
                />
              ))}
            </Stack>
          </FlexContainer>
        </Box>
      </ShowContainer>

      <TransferAccount
        open={openTransferAcc}
        setChosenList={setChosenList}
        closeModal={() => setOpenTransferAcc(false)}
        userIdList={chosenList.map((el) => users[el]?.[0])}
      />

      <DeleteAccount
        open={openDeleteAcc}
        setChosenList={setChosenList}
        closeModal={() => setOpenDeleteAcc(false)}
        userIdList={chosenList.map((el) => users[el]?.[0])}
      />
    </>
  );
}
